import axios from 'axios';
import { baseUrl, token } from '../../../services/Apis';

export const ENTIDADES_CONST = 'entidades';
export const entidadesApi = `${baseUrl}/${ENTIDADES_CONST}`;

export const allEntidadesService = async (params) => {
  const res = await axios.get(entidadesApi, {
    headers: token({}),
    params,
  });
  return res;
};

export const saveEntidadesService = async (id, data) => {
  let res;
  if (id) {
    res = await axios.patch(`${entidadesApi}/${id}`, data, {
      headers: token({}),
    });
  } else {
    res = await axios.post(`${entidadesApi}`, data, {
      headers: token({}),
    });
  }
  return res;
};

export const oneEntidadesService = async (id) => {
  const res = await axios.get(`${entidadesApi}/${id}`, {
    headers: token({}),
  });
  return res;
};

export const deleteEntidadesService = async (id, idEnt) => {
  const res = await axios.delete(`${entidadesApi}/${id}`, {
    headers: token({}),
  });
  return res;
};
